import { Component, Input } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';

@Component({
  selector: 'smrts-list-menu',
  templateUrl: './list-menu.component.html',
  styleUrls: ['./list-menu.component.scss'],
  standalone: false
})
export class ListMenuComponent {

  @Input() text: string;

  @Input() icon: string;

  @Input() link: string;

  @Input() menuDrawer: MatDrawer;

  expanded: boolean = true;

}
